var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-arrow-right-outline"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right-outline",
    clipPath: "url(#clip-arrow-right-outline)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M168.247,65h0Z",
    transform: "translate(211.779 172) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_589",
    "data-name": "Group 589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_588",
    "data-name": "Group 588",
    transform: "translate(166.483 165)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    cx: 171,
    cy: 171,
    r: 171,
    transform: "translate(-116.483 -115)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_4",
    "data-name": "Subtraction 4",
    d: "M101,42.5H0a60.147,60.147,0,0,0,10.167-.863,57.378,57.378,0,0,0,9.48-2.476,54.114,54.114,0,0,0,8.579-3.918,50.054,50.054,0,0,0,7.475-5.19,45.409,45.409,0,0,0,6.167-6.29,40.94,40.94,0,0,0,4.657-7.219,37.573,37.573,0,0,0,2.943-7.978A36.292,36.292,0,0,0,50.494,0H101V42.5h0Z",
    transform: "translate(-166.959 49)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_6",
    "data-name": "Subtraction 6",
    d: "M101,0H0A60.147,60.147,0,0,1,10.167.864a57.378,57.378,0,0,1,9.48,2.476,54.114,54.114,0,0,1,8.579,3.918,50.054,50.054,0,0,1,7.475,5.19,45.409,45.409,0,0,1,6.167,6.29,40.94,40.94,0,0,1,4.657,7.219,37.573,37.573,0,0,1,2.943,7.978A36.292,36.292,0,0,1,50.494,42.5H101V0h0Z",
    transform: "translate(89.791 -165.25) rotate(90)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_132",
    "data-name": "Rectangle 132",
    width: 105,
    height: 106,
    transform: "translate(151 150)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_585",
    "data-name": "Group 585",
    transform: "translate(196.137 134.627) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_107",
    "data-name": "Line 107",
    x1: 37.183,
    y2: 36.637,
    transform: "translate(-0.127)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_587",
    "data-name": "Group 587",
    transform: "translate(161.627 182.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_107-2",
    "data-name": "Line 107",
    x1: 37.183,
    y2: 36.637,
    transform: "translate(-3.127 -10)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 11
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightOutline);
export default __webpack_public_path__ + "static/media/arrow-right-outline.68e32f59.svg";
export { ForwardRef as ReactComponent };